const VIEW_USER_DETAILS = 'VIEW_USER_DETAILS'
const PROFILE_DETAILS = 'PROFILE_DETAILS'
const LOGOUT = 'LOGOUT'

export { VIEW_USER_DETAILS, PROFILE_DETAILS, LOGOUT }
